import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#fff"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M3.5 10a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0M10 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17m-2.4 10a1 1 0 1 0-2 .4c.3 1 .9 1.8 1.7 2.4a4.6 4.6 0 0 0 5.4 0c.8-.6 1.4-1.5 1.6-2.4a1 1 0 0 0-2-.5c0 .5-.3 1-.8 1.3a2.6 2.6 0 0 1-3 0c-.5-.4-.7-.8-.9-1.3Zm-.1-2.6a1 1 0 0 0 1.8-.7q0-.75-.6-1.2c-.3-.3-.7-.5-1.2-.5s-1 .2-1.2.5c-.4.3-.5.7-.6 1.2a1 1 0 0 0 1.8.7m6 .4a1 1 0 0 1-1-.4 1 1 0 0 1-1.8-.7q0-.75.6-1.2c.3-.3.7-.5 1.2-.5s1 .2 1.2.5c.4.3.5.7.6 1.2s-.2 1-.8 1.1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }